import { memo } from 'react'

import { MenuItem, Paper, Stack, TextField, Typography } from '@mui/material'
import { SmepLiveDelayStrategyModeEnum } from '@nativewaves/nw-cloud-sdk/smep'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { NumberField } from '../NumberField'
import type { ConfigFormValues } from '../types'

const PanelRaw = () => {
  const { t } = useTranslation(['common', 'domain'])

  const { control } = useFormContext<ConfigFormValues>()

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="heading-md" sx={{ mb: 2 }}>
        {t('domain:Workspace.Event.ConfigEditor.advanced')}
      </Typography>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <Controller
          control={control}
          name="liveDelayStrategy.mode"
          render={({ field }) => (
            <TextField
              {...field}
              select
              size="small"
              sx={{ minWidth: 220 }}
              label={t('domain:Workspace.Event.ConfigEditor.liveDelayMode')}
            >
              {Object.values(SmepLiveDelayStrategyModeEnum).map((mode) => (
                <MenuItem key={mode} value={mode}>
                  {mode}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
        <Controller
          control={control}
          name="liveDelayStrategy.realTimeDelay"
          render={({ field }) => (
            <NumberField
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              inputRef={field.ref}
              size="small"
              label={t('domain:Workspace.Event.ConfigEditor.realTimeDelay')}
            />
          )}
        />
        <Controller
          control={control}
          name="liveDelayStrategy.playbackDelay"
          render={({ field }) => (
            <NumberField
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              inputRef={field.ref}
              size="small"
              label={t('domain:Workspace.Event.ConfigEditor.playbackDelay')}
            />
          )}
        />
        <Controller
          control={control}
          name="pointZeroRealTimeReferenceShift"
          render={({ field }) => (
            <NumberField
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              inputRef={field.ref}
              size="small"
              sx={{ minWidth: 220 }}
              label={t('domain:Workspace.Event.ConfigEditor.pointZeroShift')}
            />
          )}
        />
      </Stack>
    </Paper>
  )
}

export const Panel = memo(PanelRaw)
